/* Conserva il trigger Klaviyo durante i rerender Focal, senza ricreare il popup. */
(() => {
  if (window.extroBISBridgeReady) return;
  window.extroBISBridgeReady = true;
  let trigger = null;
  let queued = false;
  let observer;
  let openRequest;
  let openTimer;

  const cancelOpen = () => {
    clearTimeout(openTimer);
    openRequest = null;
  };

  const sync = () => {
    queued = false;
    const scope = document.querySelector('[data-extro-product-hover]');
    const button = scope?.querySelector('[data-product-add-to-cart-button]');
    trigger ||= scope?.querySelector('.klaviyo-bis-trigger');
    if (!button || !trigger) return;
    observer?.disconnect();
    if (trigger.parentElement !== button.parentElement) button.after(trigger);

    // Focal aggiorna l'URL dopo il primo change: Klaviyo legge ora l'ID definitivo.
    const id = button.form?.elements.namedItem('id');
    if (id?.value) id.dispatchEvent(new Event('change', { bubbles: true }));
    const soldOut = !!button.dataset.variantId && button.dataset.variantAvailable === 'false';
    trigger.hidden = !soldOut;
    button.hidden = soldOut && trigger.style.display !== 'none';
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(sync);
  };

  const openSelectedVariant = () => {
    if (!openRequest) return;
    const scope = document.querySelector('[data-extro-product-hover]');
    const form = document.getElementById(openRequest.formId);
    if (!scope || !form || ++openRequest.attempts > 100) return cancelOpen();

    // Aspetta anche la coda di selezioni Focal: una risposta intermedia non deve aprire il popup.
    if (!scope.hasAttribute('data-extro-variant-pending')) {
      const option = form.elements.namedItem(openRequest.optionName);
      const button = scope.querySelector('[data-product-add-to-cart-button]');
      const id = form.elements.namedItem('id');
      if (option?.value !== openRequest.optionValue) return cancelOpen();
      if (button?.dataset.variantId === id?.value) {
        if (!id?.value || button.dataset.variantAvailable !== 'false') return cancelOpen();
        sync();
        if (trigger?.isConnected && !trigger.hidden && getComputedStyle(trigger).display !== 'none') {
          cancelOpen();
          trigger.click();
          return;
        }
      }
    }
    // L'SDK viene caricato in idle: conserva l'intenzione senza ricaricarlo.
    openTimer = setTimeout(openSelectedVariant, 100);
  };

  document.addEventListener('change', event => {
    if (!openRequest || !event.target.matches('[data-option-position]')) return;
    if (event.target.name !== openRequest.optionName || event.target.value !== openRequest.optionValue) cancelOpen();
  }, true);

  document.addEventListener('click', event => {
    const color = event.target.closest('variant-picker [data-extro-notify-color]');
    if (color?.closest('[data-extro-product-hover]')) {
      const control = color.control || color;
      const picker = color.closest('variant-picker');
      const values = color.dataset.extroNotifyColor.split(',').filter(Boolean);
      if (!control.name || !values.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      cancelOpen();
      openRequest = {formId:picker.getAttribute('form-id'), optionName:control.name, optionValue:control.value, attempts:0};
      // Se la taglia corrente non esiste nel colore, usa una combinazione reale.
      picker.selectCombination({optionValues:values, productChange:false}).catch(cancelOpen);
      openTimer = setTimeout(openSelectedVariant,0);
      return;
    }
    const option = event.target.closest('variant-picker combo-box button[role="option"]');
    if (!option || !option.closest('[data-extro-product-hover]')) return;
    cancelOpen();
    if (!option.hasAttribute('data-extro-notify-option')) return;
    const picker = option.closest('variant-picker');
    const control = option.closest('combo-box').nativeControl;
    if (!control) return;
    openRequest = { formId: picker.getAttribute('form-id'), optionName: control.name, optionValue: option.value, attempts: 0 };
    // Lascia che il combo-box selezioni l'opzione e si chiuda, anche al riclic sulla stessa taglia.
    openTimer = setTimeout(openSelectedVariant, 0);
  }, true);

  document.addEventListener('variant:change', schedule);
  document.addEventListener('product:rerender', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => {
    const clicked = event.target.closest('.klaviyo-bis-trigger');
    if (!clicked || !clicked.closest('[data-extro-product-hover]')) return;
    sync();
    if (clicked.hidden || clicked.closest('[data-extro-variant-pending]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Osserva solo l'arrivo iniziale del trigger, poi usa gli eventi del tema.
  observer = new MutationObserver(schedule);
  const scope = document.querySelector('[data-extro-product-hover]');
  if (scope) observer.observe(scope, { childList: true, subtree: true });
  sync();
})();
